export default "__VITE_ASSET__CTU_Y_x4__"